module.exports = __webpack_public_path__ + "e52ec61130817f04a731996b27e07ff1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/kampf.svg
// module id = 14
// module chunks = 0